import { BLUE, DARK, GOLD, LIGHT } from '../constants/colors';

export default function Section({children, title, subtitle, icon, accent=false, style={}}){
  return(
    <div style={{background:"#fff",borderRadius:18,padding:"28px 28px 24px",boxShadow:"0 2px 16px rgba(0,0,0,0.055)",border:`1px solid ${accent?"#BFDBFE":"#EEF2F7"}`,marginBottom:16,...style}}>
      {(title||icon)&&(
        <div style={{display:"flex",alignItems:"center",gap:12,marginBottom:subtitle?6:20,paddingBottom:subtitle?0:18,borderBottom:subtitle?"none":"1px solid #F1F5F9"}}>
          {icon&&<div style={{width:40,height:40,borderRadius:11,background:LIGHT,display:"flex",alignItems:"center",justifyContent:"center",fontSize:21,flexShrink:0}}>{icon}</div>}
          <div>
            {title&&<h3 style={{margin:0,fontSize:16,fontWeight:700,color:DARK,fontFamily:"sans-serif"}}>{title}</h3>}
            {subtitle&&<p style={{margin:"3px 0 0",fontSize:12,color:"#94a3b8",fontFamily:"sans-serif"}}>{subtitle}</p>}
          </div>
        </div>
      )}
      {(title||icon)&&subtitle&&<div style={{height:1,background:"#F1F5F9",marginBottom:20}}/>}
      {children}
    </div>
  );
}
